import { render, staticRenderFns } from "./PainelAgecom.vue?vue&type=template&id=b0782d1c"
import script from "./PainelAgecom.vue?vue&type=script&lang=js"
export * from "./PainelAgecom.vue?vue&type=script&lang=js"
import style0 from "./PainelAgecom.vue?vue&type=style&index=0&id=b0782d1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports